import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { AuthorizationBase } from "../../../../core/authorize-base";
import { CashPayment } from "../../../models/invoice/cash-payment.model";

@Injectable({
  providedIn: "root"
})
export class CashPaymentService extends AuthorizationBase {
  private accountBaseRoute: string;

  constructor(private httpClient: HttpClient) {
    super();
    this.accountBaseRoute = environment.accountAPIRoot;

  }

  addManualPayment(payload: CashPayment) {
    payload.CreatedBy = parseInt(super.userId().toString());
    return this.httpClient.post(environment.invoiceAPIRoot + '/cashpayment', payload);
  }


}
